import React, { Component } from "react";
import { connect } from "react-redux";
import { getComprobanteOrdenes, updateUrlTrackingApi } from '../../api/axios';
import { editOrden } from "../../actions/ordenesActions";
import { base64ToArrayBuffer, saveByteArray } from "../../utilities/formatFile";
import MiniSpinner from "../General/MiniSpinner";
import PopOver from "../General/PopOver";
import { toast } from 'react-toastify';

class Entrega extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlTracking: this.props.orden?.entrega?.entregaDomicilio?.urlTracking,
      isUpdatingUrl: false,
      urlWasUpdated: false
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  updateUrlTracking = () => {
    this.setState({ isUpdatingUrl: true });

    const req = updateUrlTrackingApi({
      idVenta: this.props.orden.idOrden,
      urlTracking: this.state.urlTracking
    });

    req.then(res => {
      this.setState({ urlWasUpdated: true });
      let orden = { ...this.props.orden };
      orden.entrega.entregaDomicilio.urlTracking = this.state.urlTracking;
      this.props.editOrden(orden);
      toast.success("Url Tracking actualizado");
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.error(error))
        : toast.error("El Url tracking no pudo ser actualizado");
    }).finally(() => {
      this.setState({ isUpdatingUrl: false });
    });
  };

  descargarOblea = (event) => {
    event.preventDefault();
    let oblea = getComprobanteOrdenes(this.props.orden.idOrden);
    oblea.then(res => {
      let pdfData = base64ToArrayBuffer(res.oblea);
      saveByteArray("Oblea", pdfData);
      toast.success("Descarga realizada");
    }).catch(err => {
      toast.error("Descarga de oblea fallida");
    });
  }


  render() {
    const { seller, entrega } = this.props.orden;
    const { userType } = this.props;
    const canEditUrlTracking =
      seller?.envioPropio ||
      userType?.isSeller ||
      userType?.isSellerAdmin ||
      userType?.isProveedor ||
      userType?.isCategory ||
      userType?.isAdminMod;
    const {
      domicilio,
      departamento,
      piso,
      codigoPostal,
      urlTracking,
      localidad,
      provincia
    } = entrega.entregaDomicilio;

    return (
      <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
        <div className="row">

          <div className="form-group col-12 col-md-6">
            <label>Calle</label>
            <input
              type="text"
              className="form-control"
              defaultValue={domicilio}
              name="calle"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label>Departamento</label>
            <input
              type="text"
              className="form-control"
              defaultValue={departamento}
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label>Piso</label>
            <input
              type="text"
              className="form-control"
              defaultValue={piso}
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label>Codigo postal</label>
            <input
              type="number"
              className="form-control"
              defaultValue={codigoPostal}
              name="codPostal"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label>Localidad</label>
            <input
              type="text"
              className="form-control"
              defaultValue={localidad}
              name="localidad"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label>Provincia</label>
            <input
              type="text"
              className="form-control"
              defaultValue={provincia}
              name="provincia"
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <label>Tipo de entrega</label>
            <input
              type="text"
              className="form-control"
              defaultValue={entrega.tipoEntrega.descripcion}
            />
          </div>

          <div className="form-group col-12 col-md-6">
            <div className="col-12 col-md-6">
              <label className="d-block">Url Tracking</label>
              {!urlTracking
                ? <span className="label label-grey me-1">Pendiente de envio</span>
                : <a target="_blank" href={urlTracking ?? "#"}>{urlTracking ?? "Pendiente de envio"}</a>
              }
              {canEditUrlTracking &&
                <PopOver
                  header={"¿Actualizar Url Tracking?"}
                  content={
                    <>
                      <div className="form-group">
                        <input
                          type="text"
                          name="urlTracking"
                          placeholder="URL Tracking"
                          className="form-control"
                          defaultValue={this.state.urlTracking}
                          onChange={this.handleChange}
                        />
                      </div>

                      <div className="mt-3 col-auto">
                        <button
                          onClick={() => this.updateUrlTracking()}
                          className="btn btn-sm background-rojo-megatone"
                          disabled={this.state.isUpdatingUrl}
                        >
                          Actualizar
                        </button>
                      </div>
                    </>
                  }
                >
                  <button
                    type="button"
                    className="btn"
                    title="Actualizar Url Tracking"
                    disabled={this.state.isUpdatingUrl}
                  >
                    <i className="fa fa-clipboard" aria-hidden="true" />
                  </button>
                </PopOver>
              }
              {this.state.isUpdatingUrl && <MiniSpinner />}
            </div>
          </div>

          <div className="form-group col-12 col-md-6">
            <div className="button-group">
              {urlTracking && !this.state.urlWasUpdated &&
                <button
                  onClick={this.descargarOblea}
                  className="btn btn-sm background-rojo-megatone"
                >
                  Descargar oblea
                </button>
              }
            </div>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  orden: state.ordenes.orden,
  userType: state.general.userType
});

export default connect(mapStateToProps, { editOrden })(Entrega);